import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// disable console log for production mode
if (environment.production) {
  console.log = function () { };
  console.error = function () { };
  console.warn = function () { };
  console.info = function () { };
  console.debug = function () { };
}

// (function () {
//   const originalSetTimeout = window.setTimeout;
//   window.setTimeout = function (
//     handler: TimerHandler,
//     timeout?: number,
//     ...args: any[]
//   ): number {
//     console.trace(`[Debug] setTimeout with ${timeout}ms`);
//     return originalSetTimeout(handler, timeout, ...args);
//   } as typeof window.setTimeout;
// })();




platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
